import { render, staticRenderFns } from "./ManualReversal.vue?vue&type=template&id=85c5108e&scoped=true&"
import script from "./ManualReversal.vue?vue&type=script&lang=js&"
export * from "./ManualReversal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c5108e",
  null
  
)

export default component.exports